import type { Edition } from "shared/lib/edition";
import { PageType } from "shared/lib/page-type";

export const pathname = "/home";

export const page = {
  route(
    query: QueryParameters<{
      edition?: Edition;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Homepage },
    };
  },
};
